import { render, staticRenderFns } from "./MessageTreeNew.vue?vue&type=template&id=4d104d42&"
import script from "./MessageTreeNew.vue?vue&type=script&lang=js&"
export * from "./MessageTreeNew.vue?vue&type=script&lang=js&"
import style0 from "./MessageTreeNew.vue?vue&type=style&index=0&id=4d104d42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports